import { createApp } from 'vue'
import App from './App.vue'
import rooter from '../src/router/index'
import install from './install'
import { VueSvgIconPlugin } from '@yzfe/vue3-svgicon'
import '@yzfe/svgicon/lib/svgicon.css'
import './registerServiceWorker'
import 'material-icons/iconfont/material-icons.css'
import i18n from './i18n'
import vuex from "./store"
// import VueApexCharts from "vue3-apexcharts"
import easySpinner from 'vue-easy-spinner'
import imageCompressor from 'vue-image-compressor'
// import VCalendar from 'v-calendar'
// import 'v-calendar/dist/style.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import vClickOutside from "click-outside-vue3"

createApp(App)
    .use(i18n)
    .use(vuex)
    // .use(VueApexCharts)
    .use(easySpinner, {
        /*options*/
        prefix: 'easy',
    })
    .use(vClickOutside)
    // .use(VCalendar, {})
    .use(imageCompressor)
    .use(VueSvgIconPlugin, { tagName: 'icon' })
    .component('VueDatePicker', VueDatePicker)
    .use(install)
    .use(rooter)
    .mount('#app')
